export type CapabilityState = {
  secureContext: boolean;
  mediaDevices: boolean;
  camera: boolean;
  microphone: boolean;
  geolocation: boolean;
};

export function getBrowserCapabilities(): CapabilityState {
  const nav = typeof navigator !== "undefined" ? navigator : undefined;
  const secureContext = typeof window !== "undefined" ? window.isSecureContext === true : false;
  const mediaDevices = !!nav?.mediaDevices && typeof nav.mediaDevices.getUserMedia === "function";
  return {
    secureContext,
    mediaDevices,
    camera: secureContext && mediaDevices,
    microphone: secureContext && mediaDevices,
    geolocation: !!nav?.geolocation && secureContext,
  };
}

export function getMediaDevicesOrNull(): MediaDevices | null {
  if (typeof navigator === "undefined") return null;
  if (typeof window !== "undefined" && !window.isSecureContext) return null;
  const md = navigator.mediaDevices;
  return md && typeof md.getUserMedia === "function" ? md : null;
}

export async function safeGetUserMedia(constraints: MediaStreamConstraints): Promise<MediaStream> {
  const md = getMediaDevicesOrNull();
  if (!md) {
    throw new Error("MEDIA_UNAVAILABLE: câmera/microfone exigem navegador compatível e HTTPS.");
  }
  return md.getUserMedia(constraints);
}

export function getGeolocationOrNull(): Geolocation | null {
  // Do not pre-emptively hide the API on HTTP. Browsers that require a secure
  // context will reject the actual request, which the UI handles gracefully.
  // This also preserves compatibility with managed/webview environments that
  // expose geolocation under an application-level permission model.
  if (typeof navigator === "undefined") return null;
  return navigator.geolocation ?? null;
}
